/* Single Image banner with no buttons/icons */

import Image from 'next/image';
import PropTypes from 'prop-types';
import styles from './styles';

const ImageBanner = ({ bannerImage, bannerImageMobile }) => {
  if (!bannerImage) {
    return '';
  }
  return (
    <>
      <div className="top_banner">
        <div className="banner_container">
          <div className="banner_image">
            <div className="banner_image_desktop">
              <Image draggable={false}
                layout="responsive"
                src={bannerImage.url}
                alt={bannerImage.alt}
                width={bannerImage.dimensions.width}
                height={bannerImage.dimensions.height}
              />
            </div>
            <div className="banner_image_mobile">
              <Image draggable={false}
                src={bannerImageMobile.url}
                alt={bannerImageMobile.alt}
                width={bannerImageMobile.dimensions.width}
                height={bannerImageMobile.dimensions.height}
              />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

ImageBanner.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  bannerImage: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  bannerImageMobile: PropTypes.object.isRequired,
};

export default ImageBanner;
